import { Divider, ListItem, Typography } from "@mui/material";
import IconUserSpecialist from "components/Icons/IconUserSpecialist";
import { GridEx } from "components/MuiExtras/Grid/GridEx";
import MuiMuted from "components/MuiExtras/Typography/MuiMuted";
import { TextPluralization } from "components/TextPluralization";
import HtmlUtils from "lib/HtmlUtils";
import { GlobalSearchItem } from "models/ApiModels";
import * as React from "react";
import { RoutePaths } from "routes/RouteConfig";

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    data: GlobalSearchItem;
    index: number;
    showDivider: boolean;
}

type Props = IProps;

/////////////////////////////////////////////////////////////////////////////////////////////////

export const SearchRenderUser: React.FC<Props> = (props) => {

    const { data, index, showDivider } = props;

    const link = RoutePaths.UserProfileViewer.replace(":id?", data.id);

    return (
        <React.Fragment key={"seachItem-" + index}>
            <ListItem
                button
                onClick={
                    () => {
                        HtmlUtils.openUrlInNewWindow(link);
                    }
                }
            >
                <GridEx container wrap="nowrap" spacing={1}>
                    <GridEx item>
                        <img src={data.thumbnailUrl} alt={data.title} width="48" />
                    </GridEx>
                    <GridEx item xs>
                        <div>
                            <Typography variant="body1" color="secondary">
                                {data.title}
                                {data.isSpecialist && <>&nbsp;<IconUserSpecialist active color="success" /></>}
                            </Typography>
                        </div>
                        <MuiMuted>
                            <Typography variant="caption">
                                {
                                    data.additionalInfo &&
                                    <>
                                        <span> {data.additionalInfo}</span>
                                        <span> &ndash;</span>
                                    </>
                                }
                                <span> <TextPluralization count={data.totalPublications} resource="Views.Search.Components.SearchRenderUser.PublicationText" /></span>
                            </Typography>
                        </MuiMuted>
                    </GridEx>
                </GridEx>
            </ListItem>
            {showDivider && <Divider />}
        </React.Fragment>
    );
};
